<template>
  <div>
    <div class="mainWrapper">
      <MainSideBarVue />

      <div class="rightContentWrapper">
        <div class="topNav">
          <TopBarVue />
        </div>

        <div class="innerContainer">
          <div class="theHeaderWrapper">
            <div>Teams</div>

            <div class="headerActions">
              <button
                class="button-6"
                role="button"
                @click="teamStore.openCreateTeamModal"
              >
                New Team +
              </button>

              <div class="dropdown">
                <i
                  class="bi bi-three-dots-vertical iconDrop"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                ></i>

                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li @click="teamStore.openTeamDeletionLogsModal">
                    <a class="dropdown-item" href="#">Team Deletion Logs</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="searchBarWrapper">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control theBar"
              placeholder="Search by team name..."
            />
          </div>

          <div v-if="teamStore.teams.length > 0">
            <div class="tableWrapper">
              <table class="table table-hover my-custom-table">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Users</th>
                    <th scope="col">Invite Link</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>

                <tbody v-if="filteredTeams.length > 0">
                  <tr v-for="(team, index) in filteredTeams" :key="index">
                    <td style="width: 300px">{{ team.name }}</td>

                    <td style="width: 300px">
                      <router-link
                        v-if="team.team_count !== 0"
                        :to="{
                          name: 'ViewATeam',
                          params: { random_string: team.random_string },
                        }"
                      >
                        <span class="badge rounded-pill bg-success">
                          <!-- {{ team.user_teams.length }} users -->

                          View

                          <!-- {{ team.team_count }} users -->
                        </span>
                      </router-link>

                      <div v-else>No users</div>
                    </td>

                    <td>
                      <input
                        :id="'inviteLinkInputField' + index"
                        @click="teamStore.copyLink(index)"
                        readonly
                        type="text"
                        class="form-control inviteInput"
                        :value="teamStore.buildInviteLink(team.id)"
                      />
                    </td>

                    <td style="width: 150px">
                      <div class="iconsRow">
                        <i
                          @click="
                            () => {
                              teamStore.setCurrentTeam(team);
                              teamStore.openEditTeamModal();
                            }
                          "
                          class="bi bi-pencil theActionIcon"
                        ></i>

                        <div v-if="!team.supervisor">
                          <i
                            @click="
                              () => {
                                teamStore.setCurrentTeam(team);
                                teamStore.openDeleteTeamModal();
                              }
                            "
                            class="bi bi-trash theActionIcon"
                          ></i>
                        </div>

                        <div v-else>
                          <i
                            @click="teamStore.openDeleteSupervisorTeamModal(team)"
                            class="bi bi-trash theActionIcon"
                          ></i>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <button
                v-if="displayedTeamsCount < teamStore.teams.length"
                class="btn btn-dark loadMoreBtn"
                @click="loadMoreTeams"
              >
                Load more
              </button>
            </div>
          </div>

          <div class="noTeamBox" v-else>No teams created yet.</div>
        </div>
      </div>
    </div>

    <div v-if="teamStore.showCreateTeamModal" class="modal-overlay">
      <div class="modal-box" style="width: 550px">
        <div class="model-box-header">
          <div style="font-size: 17px">
            <b>New Team</b>
          </div>

          <div>
            <i
              @click="teamStore.closeCreateTeamModal"
              class="bi bi-x-lg"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </div>
        </div>

        <div class="modal-content">
          <form @submit.prevent="teamStore.storeNewTeam">
            <div class="mb-3">
              <label class="form-label" style="float: left"><b>Name</b></label>
              <input
                v-model="teamStore.formData.name"
                type="text"
                class="form-control inputStyle"
                placeholder="Team name"
                required
              />
            </div>

            <div>
              <button type="submit" class="btn btn-dark createBTN">
                <b>Create</b>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="teamStore.showEditTeamNameModal" class="modal-overlay">
      <div class="modal-box" style="width: 550px">
        <div class="model-box-header">
          <div style="font-size: 17px">
            <b>Edit Team</b>
          </div>

          <div>
            <i
              @click="teamStore.closeEditTeamModal"
              class="bi bi-x-lg"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </div>
        </div>

        <div class="modal-content">
          <form @submit.prevent="teamStore.updateThisTeam">
            <div class="mb-3">
              <label class="form-label" style="float: left"><b>Name</b></label>
              <input
                v-model="teamStore.formData.name"
                type="text"
                class="form-control inputStyle"
                placeholder="Team name"
                required
              />
            </div>

            <div>
              <button type="submit" class="btn btn-dark createBTN">
                <b>Update</b>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="teamStore.showDeleteTeamModal" class="modal-overlay">
      <div class="modal-box" style="width: 550px">
        <div class="model-box-header">
          <div style="font-size: 17px; text-align: left">
            <b>Are you sure you want to delete this team?</b>
          </div>

          <div>
            <i
              @click="teamStore.closeDeleteTeamModal"
              class="bi bi-x-lg"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </div>
        </div>

        <div class="modal-content" style="text-align: left">
          <p>
            <b style="color: red">Very Important Note:</b> Deleting
            <b>{{ teamStore.currentTeam.name }}</b> also remove all employees that have
            registered under this team's link. And it also deletes any campaign related to
            this team. This data cannot be recovered when deleted.
          </p>

          <div class="alert alert-danger" role="alert" style="color: black">
            <div class="form-check d-flex align-items-center">
              <div
                v-if="teamStore.isTeamDeletionPermissionChecked"
                @click="teamStore.updateTeamDeletionSelection"
                class="form-check form-switch me-3"
              >
                <input
                  class="form-check-input theInputSwitch"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  checked
                />
              </div>

              <div
                v-else
                class="form-check form-switch me-3"
                @click="teamStore.updateTeamDeletionSelection"
              >
                <input
                  class="form-check-input theInputSwitch"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                />
              </div>

              <label
                v-if="teamStore.currentUser && teamStore.currentUser.name"
                class="form-check-label flex-grow-1"
                for="confirmDelete"
              >
                I, <strong>{{ teamStore.currentUser.name }}</strong
                >, acknowledge that all data relating to this team will be
                <u>permanently deleted</u> and is <u>unrecoverable</u>. This includes all
                members, settings, and associated records.
              </label>
            </div>
          </div>

          <div>
            <button
              @click="teamStore.deleteTeam"
              type="button"
              class="btn btn-danger createBTN"
            >
              <b>Yes, Delete!</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="teamStore.showDeleteSupervisorTeamModal" class="modal-overlay">
      <div class="modal-box" style="width: 550px">
        <div class="model-box-header">
          <div style="font-size: 17px; text-align: left">
            <b
              >Are you sure you want to delete this
              {{ teamStore.currentTeam.name }} team?</b
            >
          </div>

          <div>
            <i
              @click="teamStore.closeDeleteSupervisorTeamModal"
              class="bi bi-x-lg"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </div>
        </div>

        <div class="modal-content" style="text-align: left; font-size: 15px; padding: 15px;">
          <p>
            <b style="color: red">Very Important Note:</b> Deleting
            <b>{{ teamStore.currentTeam.name }}:</b>
          </p>

          <li>
            Deletes the supervisor of this team
            <span
              v-if="
                teamStore.currentTeam.supervisor && teamStore.currentTeam.supervisor.name
              "
            >
              <b>{{ teamStore.currentTeam.supervisor.name }}</b>
            </span>
          </li>

          <li>Remove all employees that are under this team</li>
          <li>
            Deletes any group talk data related to this team.
            <b>This data cannot be recovered when deleted.</b>
          </li>

          <div class="alert alert-danger" role="alert" style="color: black; margin-top: 20px;">
            <div class="form-check d-flex align-items-center">
              <div
                v-if="teamStore.isTeamDeletionPermissionChecked"
                @click="teamStore.updateTeamDeletionSelection"
                class="form-check form-switch me-3"
              >
                <input
                  class="form-check-input theInputSwitch"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  checked
                />
              </div>

              <div
                v-else
                class="form-check form-switch me-3"
                @click="teamStore.updateTeamDeletionSelection"
              >
                <input
                  class="form-check-input theInputSwitch"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                />
              </div>

              <label v-if="teamStore.currentUser && teamStore.currentUser.name" class="form-check-label flex-grow-1" for="confirmDelete">
                I, <strong>{{ teamStore.currentUser.name }}</strong>, acknowledge that all data relating to
                this team will be <u>permanently deleted</u> and is <u>unrecoverable</u>.
                This includes all members, settings, and associated records.
              </label>
            </div>
          </div>

          <div>
            <button
              @click="teamStore.deleteThisSupervisorTeam"
              type="button"
              class="btn btn-danger createBTN"
            >
              <b>Yes, Delete!</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="teamStore.showTeamDeletionLogsModal" class="modal-overlay">
      <div class="modal-box" style="width: 550px">
        <div class="model-box-header">
          <div style="font-size: 17px">
            <b>Team Deletion Logs</b>
          </div>

          <div>
            <i
              @click="teamStore.closeTeamDeletionLogsModal"
              class="bi bi-x-lg"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </div>
        </div>

        <div class="modal-content">
          <div
            v-if="teamStore.teamDeletionLogs.length > 0"
            class="deletion-logs-container"
          >
            <table class="table table-hover">
              <thead class="table-light">
                <tr>
                  <th>Team</th>
                  <th>Deleted By</th>
                  <th>Time & Date</th>
                </tr>
              </thead>

              <tbody style="font-size: 14px">
                <tr v-for="(log, index) in teamStore.teamDeletionLogs" :key="index">
                  <td>{{ log.deleted_team_name }}</td>
                  <td>{{ log.name_of_user }}</td>
                  <td>{{ log.created_at }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else>No records found.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import MainSideBarVue from "@/components/MainSideBar";
import TopBarVue from "@/components/TopBar.vue";
import { onMounted, ref, computed } from "vue";

import { useTeamStore } from "@/stores/TeamStore";

const teamStore = useTeamStore();
const searchQuery = ref("");

const displayedTeamsCount = ref(15); // Start with displaying 5 teams
const incrementStep = 15; //

const filteredTeams = computed(() => {
  return teamStore.teams
    .filter((team) => team.name.toLowerCase().includes(searchQuery.value.toLowerCase()))
    .slice(0, displayedTeamsCount.value);
});

const loadMoreTeams = () => {
  displayedTeamsCount.value += incrementStep;
};

// const filteredTeams = computed(() => {

//   return teamStore.teams.filter(team =>
//     team.name.toLowerCase().includes(searchQuery.value.toLowerCase())

//   );

// });

onMounted(() => {
  teamStore.fetchAllTeams();
  teamStore.fetchUser();
});
</script>

<style scoped>
.mainWrapper {
  /* background-color: aliceblue; */
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.rightContentWrapper {
  /* overflow-y: auto; */
  width: 83%;
  display: flex;
  flex-direction: column;
}

.contentContainer {
  /* overflow-y: auto; */
  background-color: rgb(208, 28, 55);
  /* margin: 30px; */
  margin-top: 100px;
}

.rightColumns {
  /* display: flex;
  flex-direction: column; */
}

.topNav {
  background-color: blue;
}

.innerContainer {
  /* margin-top: 200px; */
  /* background-color: blueviolet; */
  overflow-y: auto;
  padding-top: 30px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 100px;
}

.searchBarWrapper {
  margin-top: 15px;
  width: 100%;
  padding-bottom: 20px;
  /* background-color: rgb(22, 166, 37); */
}

.theBar {
  width: 350px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 10px;
}

.button-6 {
  align-items: center;
  /* background-color: #FFFFFF; */
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  display: inline-flex;
  font-family: system-ui, -apple-system, system-ui, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-size: 16px;
  font-weight: 600;
  justify-content: center;
  line-height: 1.25;
  margin: 0;
  min-height: 3rem;
  padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
  position: relative;
  text-decoration: none;
  transition: all 250ms;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
  width: auto;
}

.button-6:hover,
.button-6:focus {
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
  color: rgba(0, 0, 0, 0.65);
}

.button-6:hover {
  transform: translateY(-1px);
}

.button-6:active {
  background-color: #f0f0f1;
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
  color: rgba(0, 0, 0, 0.65);
  transform: translateY(0);
}

.tableWrapper {
  margin-top: 20px;
  /* background-color: aqua; */
  width: 100%;
}

.my-custom-table tbody tr td {
  padding-top: 20px;
  /* Adjust the value as needed */
  padding-bottom: 20px;
  /* Adjust the value as needed */
}

.my-custom-table th {
  padding-bottom: 20px;
}

.my-custom-table th,
.my-custom-table td {
  text-align: left;
  /* Aligns text to the left */
  padding-left: 20px;
  padding-right: 20px;
}

.campName {
  text-decoration: none;
  color: inherit;
}

.campName:hover {
  color: rgb(10, 159, 92);
  cursor: pointer;
  text-decoration: none;
}

.iconsRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.theActionIcon {
  font-weight: bolder;
  font-size: 18px;
  color: rgb(5, 2, 2);
  cursor: pointer;
}

.theActionIcon:hover {
  cursor: pointer;
  color: rgb(30, 158, 30);
  scale: 1.3;
  transition: 1s;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  /* Semi-transparent black background */
  display: flex;
  justify-content: center;
  /* Center horizontally */
  align-items: center;
  /* Center vertically */
  z-index: 999;
  /* Ensure the modal is on top */
}

/* Styles for the modal box */
.modal-box {
  background-color: white;
  width: 1100px;
  padding: 20px;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-content {
  text-align: center;
}

.model-box-header {
  display: flex;
  justify-content: space-between;
  /* background-color: antiquewhite; */
  height: 40px;
  margin-bottom: 15px;
}

.form-control {
  background-color: rgb(243, 246, 246);
}

.createBTN {
  width: 100%;
  margin-top: 20px;
}

.noTeamBox {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  width: 100%;
}

.noMatchBox {
  background-color: red;
  width: 100%;
}

.loadMoreBtn {
  background-color: black;
  border-radius: 10px;
}

.inviteInput {
  width: 500px;
  font-size: 13px;
  cursor: pointer;
}

.iconDrop {
  cursor: pointer;
}

.theHeaderWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  /* background-color: aqua; */
}

.headerActions {
  display: flex;
  align-items: center;
  gap: 31px;
}

.dropdown-item {
  font-size: 13px;
}

.dropdown-item:hover,
.dropdown-item:focus {
  background-color: #f2f2f2;
  color: #000;
}

.dropdown-item:active,
.dropdown-item.active {
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  color: #000;
}

.deletion-logs-container {
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}

.deletion-logs-container table {
  margin-bottom: 0;
}

.deletion-logs-container thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.theInputSwitch {
  font-size: 20px;
  cursor: pointer;
  color: red;
}

.form-check-input:checked {
  background-color: #d84617;
  border-color: black;
  border-width: 2px;
}
</style>
